import { render, staticRenderFns } from "./addTopic.vue?vue&type=template&id=5610a14d&scoped=true"
import script from "./addTopic.vue?vue&type=script&lang=js"
export * from "./addTopic.vue?vue&type=script&lang=js"
import style0 from "./addTopic.vue?vue&type=style&index=0&id=5610a14d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5610a14d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5610a14d')) {
      api.createRecord('5610a14d', component.options)
    } else {
      api.reload('5610a14d', component.options)
    }
    module.hot.accept("./addTopic.vue?vue&type=template&id=5610a14d&scoped=true", function () {
      api.rerender('5610a14d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/quesbank-manage/addTopic.vue"
export default component.exports